export default {
    API_ENDPOINT: 'https://mysterious-lowlands-90540.herokuapp.com/api',
    //API_ENDPOINT: 'http://localhost:8000/api',
    APPID:'plX8VD1DPX0N',
    SEARCH_KEY:'db86cffac7f634ffb4975e0cc879b169',
    TOKEN_KEY:  '71448d7d-be5b-4dba-8157-4c0d21fb34e6'
}


